/* eslint-disable @typescript-eslint/no-unused-vars */
import React,{useState} from 'react';
import { TypeFiles, TypeOperations, TypeStatus } from '../../core/enum';
import { DropdownList } from '../DropdownList';
import Datepicker from "tailwind-datepicker-react";
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { formatDate_YYYYMMDD } from '../../core/function/function-generic';

const options: any = {
	title: "",
	autoHide: true,
	todayBtn: false,
    todayBtnText: 'Choose Date',
	clearBtn: true,
    clearBtnText: 'Cancel',
	theme: {
		background: "bg-white dark:bg-white",
		todayBtn: "bg-today",
		clearBtn: "bg-dateClean",
		icons: "bg-white dark:bg-white color-date-000",
		text: "color-date-000",
		disabledText: "color-date-949494",
		input: "",
		inputIcon: "",
		selected: "color-date-selected-fff",
	},
	icons: {
		prev: () => <ChevronLeftIcon className='w-4' />,
		next: () => <ChevronRightIcon className='w-4' />,
	},
	datepickerClassNames: "top-12",
	defaultDate: new Date(),
	language: "en",
}
interface DocumentFilterProps {
    handleDownload: (params: any) => void;
}
  
export const DocumentFilter: React.FC<DocumentFilterProps> = ({ handleDownload }) => {
    const [state, setState] = useState<any>({
        fileType: '',
        status: '',
        fromDate: '',
        toDate: '',
        typeOperation: ''
    })

    const handleChange = (event: any) =>{
        setState((prevProps: any)=>({
            ...prevProps,
            [event.target.name] : event.target.value
        }))
    }

    const handleSubmit = (event: any)=>{ 
        event.preventDefault();
        if(state.fromDate === '' && state.toDate === '') return;
        handleDownload(state)
    }

    const onValueSelect = (event: any, name: string) =>{ 
        setState((prevProps: any)=>({
            ...prevProps,
            [name] : event
        }))
    }

    const [showfromDate, setShowfromDate] = useState(false)
    const [showtoDate, setShowtoDate] = useState(false)
    const [selectedDatefromDate, setSelectedDatefromDate] = useState<any>(null)
    const [selectedDatetoDate, setSelectedDatetoDate] = useState<any>(null)

	const handleChangefromDate = (selectedDate: any) => {
        setSelectedDatefromDate(formatDate_YYYYMMDD(selectedDate))
        setState((prevProps: any)=>({
            ...prevProps,
            fromDate : formatDate_YYYYMMDD(selectedDate)
        }))
	}
	const handleChangetoDate = (selectedDate: any) => {
        setSelectedDatetoDate(formatDate_YYYYMMDD(selectedDate))
        setState((prevProps: any)=>({
            ...prevProps,
            toDate : formatDate_YYYYMMDD(selectedDate)
        }))
	}

	const handleClosefromDate = (state: any) => {
		setShowfromDate(state)
	}
	
    const handleClosetoDate = (state: any) => {
		setShowtoDate(state)
	}

    return (
        <form className="" onSubmit={handleSubmit}>
            <div className='grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 py-6 gap-8 w-full'>
                <div className="flex flex-col gap-2">
                    <DropdownList nameInput="typeOperation" labelName={'Operation Type'} onValueData={onValueSelect} dataOption={Object.values(TypeOperations)} />
                </div>

                <div className="flex flex-col gap-2">
                    <DropdownList nameInput="fileType" labelName={'Document Type'} onValueData={onValueSelect} dataOption={Object.values(TypeFiles)} />
                </div>
                
                <div className="flex flex-col gap-2">
                    <DropdownList nameInput="status" labelName={'Status'} onValueData={onValueSelect} dataOption={Object.values(TypeStatus)} />
                </div>
                <div>
                    <Datepicker classNames='bg-white' options={options} onChange={handleChangefromDate} show={showfromDate} setShow={handleClosefromDate}>
                        <div className="border-input p-2.5">
                            <input type="text" className="" name='fromDate'  placeholder="Start Date" value={selectedDatefromDate} onFocus={() => setShowfromDate(true)} readOnly />
                        </div>
                    </Datepicker>
                </div>
                <div>
                    <Datepicker classNames='bg-white' options={options} onChange={handleChangetoDate} show={showtoDate} setShow={handleClosetoDate}>
                        <div className="border-input p-2.5">
                            <input type="text" className="" name='toDate'  placeholder="End Date" value={selectedDatetoDate} onFocus={() => setShowtoDate(true)} readOnly />
                        </div>
                    </Datepicker>
                </div>
            </div>

            <div className='grid grid-cols-12'>
                <button 
                    className="btn-upload-submit"
                    type = "submit"
                >
                    Download
                </button>
            </div>

        </form>
    )
}